import React, { useState } from 'react'
import ModalActionButton from '../../elements/ModalActionButton'
import NumberField from '../../elements/form/NumberField'
import TextareaField from '../../elements/form/TextareaField'
import { useDispatch } from 'react-redux'
import { ERROR, SET_SUCCESS } from '../../../store/types'
import { authHeader, baseUrl } from '../../../utils'
import axios from 'axios'
import OTPInput from '../../elements/form/OtpInput'

const EnablePartPayment = ({assignment, closeFunction}) => {
  const [processing, setProcessing] = useState(false)
  const [partPaymentPayload, setPartPaymentPayload] = useState({})
  const [validationErrors, setValidationErrors] = useState({})
  const [requirePasscode, setRequirePasscode] = useState(false)

  const dispatch = useDispatch()

  const validateForm = () => {
      let errors = {}

      if(!partPaymentPayload.minimumAmount || partPaymentPayload.minimumAmount === '' || partPaymentPayload.minimumAmount < 1){
          errors.minimumAmount = true
      }

      if(!partPaymentPayload.totalPayments || partPaymentPayload.totalPayments === '' || partPaymentPayload.totalPayments < 1){
          errors.totalPayments = true
      }

      if(!partPaymentPayload.description || partPaymentPayload.description === ''){
          errors.description = true
      }

      setValidationErrors(errors)
      return errors
  }

  const pushUpdate = async () => {
      if (Object.values(validateForm()).includes(true)) {
          dispatch({
              type: ERROR,
              error: {response: {data: {
                  message: 'Please check the highlighted fields'
              }}}
          })
          return
      }

      try {
          const headers = authHeader()
          setProcessing(true)
          await axios.post(`${baseUrl}/invoice-assignments/${assignment._id}/enable-part-payments`, partPaymentPayload, {headers})
          setProcessing(false)
          dispatch({
              type: SET_SUCCESS,
              payload: 'enable part payment process initiated successfully, please provide OTP to confirm.'
          })
          setRequirePasscode(true)
          // closeFunction()
          
      } catch (error) {
          console.log(error)
          dispatch({
              type: ERROR,
              error
          })
          setProcessing(false)
      }
  }

  const [passcode, setPasscode] = useState('')

  const confirmUpdate = async() => {
      if(passcode === '' || passcode.length < 6) {
          return
      }
      try {
          const headers = authHeader()
          setProcessing(true)
          await axios.post(`${baseUrl}/invoice-assignments/${assignment._id}/enable-part-payments/confirm`, {confirmationCode: passcode}, {headers})
          setProcessing(false)
          dispatch({
              type: SET_SUCCESS,
              payload: 'part payments enabled successfully!'
          })
          // se(true)
          closeFunction()
          
      } catch (error) {
          console.log(error)
          dispatch({
              type: ERROR,
              error
          })
          setProcessing(false)
      }
  }

  return (
    <div className='w-full'>
      <p className='text-sm text-gray-600 mb-[20px]'>Enable part payments for the invoice <span className='font-[550] text-gray-800'>{assignment.invoice.name} ({assignment.invoice.invoiceCode})</span> assigned to <span className='font-[550] text-gray-800'>{assignment.student.fullName}</span></p>
      <div className='w-full my-2'>
        <NumberField
          inputType="number" 
          fieldId={`discount-amount`}
          inputPlaceholder={`Maximum payments`}
          inputLabel={`Maximum payments count`} 
          requiredField={true}
          preloadValue={partPaymentPayload.totalPayments || ''}
          hasError={validationErrors.totalPayments} 
          returnFieldValue={(value)=>{setPartPaymentPayload({...partPaymentPayload, totalPayments: value})}}
        />
        <label className='inline-block text-xs text-gray-500 mt-[5px]'>Maximum number of payments that the assignee can make.</label>
      </div>

      <div className='w-full my-2'>
        <NumberField
          inputType="number" 
          fieldId={`discount-amount`}
          inputPlaceholder={`Minimum amount payable`}
          inputLabel={`Minimum amount`} 
          requiredField={true}
          preloadValue={partPaymentPayload.minimumAmount || ''}
          hasError={validationErrors.minimumAmount} 
          returnFieldValue={(value)=>{setPartPaymentPayload({...partPaymentPayload, minimumAmount: value})}}
        />
        <label className='inline-block text-xs text-gray-500 mt-[5px]'>Minimum payment amount per installment.</label>

      </div>

      <div className='my-2 w-full'>
        <TextareaField
          inputLabel="Descripton/Reason" 
          fieldId="description-note" 
          inputType="text" 
          requiredField={true}
          preloadValue={partPaymentPayload.descripton || ''}
          inputPlaceholder={`Write a short description or justifucation for allowing part payments`}
          hasError={validationErrors.description} 
          returnFieldValue={(value)=>{setPartPaymentPayload({...partPaymentPayload, ...{description: value}})}}
        />
      </div>

      {requirePasscode && <div className='w-[80%] mx-auto mt-[20px]'>
        <p className='text-sm text-green-600 mb-[10px]'>Please check your email. We sent a 6-digit OTP to approve this action.</p>
        <OTPInput length={6} onChange={(value) => {setPasscode(value)}} />
      </div>}

      <div className="mt-8 flex flex-row-reverse gap-x-4">
        {!requirePasscode? 
        <ModalActionButton
          buttonLabel={`Enable Part Payment`}
          buttonAction={()=>{pushUpdate()}}
          processing={processing}
        />
        : 
        <ModalActionButton
          buttonLabel={`Confirm Part Payment`}
          buttonAction={()=>{confirmUpdate()}}
          processing={processing}
        />
        }

        <button
            type="button"
            className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
            onClick={closeFunction}
        >
            Cancel
        </button>
      </div>
    </div>
  )
}

export default EnablePartPayment